import React from 'react';

const AppTokenError = ({ message }) => (
    <div className="mt-5 mb-5">
        <h1>Zugang nicht möglich</h1>
        <div id="af_errors" className="errors">
			<div className="alert-danger">
				<p>{message}</p>
			</div>
		</div>
        <p>Falls Sie Fragen haben, wenden Sie sich bitte an die GWG.</p>
    </div>
);

export default AppTokenError;
